import { useState } from "react";
import { View } from "react-native";
import { Text } from "react-native-paper";
import { PopOver, Button } from "../../components";
import CheckboxItem from "../../components/CheckboxItem";

export default function ActivityReviewPopOver({ onDontShowAgain }: { onDontShowAgain(): void }) {
  const [visible, setVisible] = useState(true);
  const [checked, setChecked] = useState(false);

  const onDismiss = () => {
    if (checked) {
      onDontShowAgain();
    }
    setVisible(false);
  };

  return (
    <PopOver onDismiss={onDismiss} visible={visible} showCloseIcon={true} dismissable={false} size="md">
      <Text className="text-title-2 font-700 text-ink-darkest mt-12">Deferred compensation activity reviews</Text>
      <Text className="text-title-5 text-ink-darkest font-700 mt-8">What is an activity review?</Text>
      <Text className="text-regular-normal font-400 text-ink-dark mt-4">
        The PGA's Deferred Compensation Plan requires that, prior to points being allocated to a Member's account, eligible
        activities must be reviewed and confirmed by a designated Member.
      </Text>
      <Text className="text-title-5 text-ink-darkest font-700 mt-8">How does it work?</Text>
      <Text className="text-regular-normal font-400 text-ink-dark mt-4">
        Once a Member has completed a Deferred Compensation activity, it must be reviewed and confirmed by another Member in
        order to be eligible for points. Members will use the app to assign the activity to another Member who can attest to its
        completion. Activities must be reviewed and confirmed within 60 days of submission.
      </Text>
      <View className="lg:flex-row lg:items-end">
        <Button className="mt-8" mode="contained" onPress={onDismiss}>
          Continue to Activity Review
        </Button>

        <CheckboxItem
          labelStyle="text-regular font-500 text-left text-ink-dark"
          className="px-0 lg:px-4"
          label="Don't show again"
          value={checked}
          onChange={setChecked}
        />
      </View>
    </PopOver>
  );
}
